<template>
  <div>
    <v-card class="mx-auto" width="256" tile>
      <v-navigation-drawer permanent>
        <div class="text-center" style="padding-top: 20px;">
          <v-chip class="ma-2" color="teal darken-1" text-color="white">
            <v-avatar left>
              <v-icon small>mdi-office-building-marker-outline</v-icon>
            </v-avatar>
            <strong>widget</strong> Elements
          </v-chip>
        </div>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group v-model="itemWidget" color="teal accent-2">
            <v-virtual-scroll
              :bench="benchedWidgets"
              :items="widgets"
              height="300"
              item-height="40"
              class="dark"
            >
              <template v-slot="{ item }">
                <WidgetComponent :widget="item" />
              </template>
            </v-virtual-scroll>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-card>
    <br />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

import WidgetComponent from '@/components/Widget/Widget'

export default {
  name: 'widgetsComponent',
  components: {
    WidgetComponent
  },
  data() {
    return {
      itemWidget: null
    }
  },
  props: {
    widgets: {
      required: true,
      type: Array,
      default: []
    },
    benchedWidgets: {
      required: true,
      type: Number,
      default: 0
    }
  },
  methods: {}
}
</script>

<style scoped>
.v-card {
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0.0) !important;
}

.dark {
  scrollbar-width: thin;
  scrollbar-color: #3e3e3e #202020;
}

.dark::-webkit-scrollbar {
  width: 15px;
}

.dark::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.dark::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.dark::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Widget/Index.vue